import React, { useEffect } from 'react'
import fileImg from '../../../assets/images/file.png'
import moment from 'moment';

function ScriptFiles({ langLocal, translate, arr }) {
    return (
        <div className="container-details shadow_main">
            <div className='all-files' dir={langLocal === 'ar'? "rtl":"ltr"}>
                <h4 className={`header-title ${langLocal === 'ar' ? "textAlignRight" : ""}`}>{translate('summaries-attachments-files')}</h4>
                <br></br>
                <div className='files' >
                    {
                        arr.summaries.map((file) => {
                            return (

                                <div className='one-file' >
                                    <a href={`${file.file_path}`} target="_blank" download><i className='fa fa-download' ></i></a>
                                    <img src={fileImg} />
                                    <h2>{file.episode_number}</h2>
                                    <p>{file.description}</p>
                                    <span className='file-format'>pdf</span>
                                    <hr />
                                    <div class='file-info'>
                                        <span>{moment(file.created_at).format("YYYY-MM-DD")}</span>
                                        <span>2.0MB</span>
                                    </div>
                                </div>

                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default ScriptFiles